<template>
  <div>
    <LayoutContent>
      <SectionTitle :label="$t('label.addressBook')" />
      <v-tabs v-model="selectedTab" centered class="transparent">
        <v-tab class="text-h6 text-capitalize font-weight-bold tab">{{ $t('label.delivery') }}</v-tab>
        <v-tab class="text-h6 text-capitalize font-weight-bold tab">{{ $t('label.billing') }}</v-tab>
      </v-tabs>
      <div class="d-flex flex-row flex-wrap justify-space-between">
        <v-card v-for="(address, index) in addressList" :key="index" rounded :width="$vuetify.breakpoint.smAndUp ? '48%' : '100%'" class="my-10">
          <v-card-title class="primary lighten-1 rounded-lg rounded-bl-0 rounded-br-0 white--text">
            <label class="radio--container flex-grow-1" v-if="selectedTab === 0">
              <input type="radio" name="address" :id="address.id" :value="address.id" v-model="selectedDeliveryAddress" @change="deliveryAddressChange" />
              <span class="radio-marker"></span>
              <span class="text-body-1 font-weight-bold">{{ selectedDeliveryAddress === address.id ? $t('label.deliverToHere') : $t('label.tickToDeliverToHere') }}</span>
            </label>
            <label class="radio--container flex-grow-1" v-else-if="selectedTab === 1">
              <input type="radio" name="address" :id="address.id" :value="address.id" v-model="selectedBillingAddress" @change="billingAddressChange" />
              <span class="radio-marker"></span>
              <span class="text-body-1 font-weight-bold">{{ selectedTab === 0 ? $t('label.billingToHere') : $t('label.tickToBillToHere') }}</span>
            </label>
            <router-link
              class="white--text text-decoration-none text-body-2 ml-4 font-weight-medium"
              :to="{ name: $route.path === '/order/address-book' ? $constants.ROUTE_NAME.ORDER_EDIT_ADDRESS : $constants.ROUTE_NAME.PROFILE_EDIT_ADDRESS, params: { addressId: address.id } }"
            >
              {{ $t('label.edit') }}
            </router-link>
          </v-card-title>
          <v-card-text class="py-2">
            <h5 class="secondary--text text--lighten-2">{{ $t('label.addressName') }}</h5>
            <p class="black--text text-body-2">{{ address.address_name }}</p>
            <h5 class="secondary--text text--lighten-2">{{ $t('label.receiverName') }}</h5>
            <p class="black--text text-body-2">{{ address.receiver_name }}</p>
            <h5 class="secondary--text text--lighten-2">{{ $t('label.contactNo') }}</h5>
            <p class="black--text text-body-2">{{ address.contact_no }}</p>
            <h5 class="secondary--text text--lighten-2">{{ $t('label.floorOrUnitNumber') }}</h5>
            <p class="black--text text-body-2">{{ address.floor_unit_number }}</p>
            <h5 class="secondary--text text--lighten-2">{{ $t('label.address') }}</h5>
            <p class="black--text text-body-2">{{ address.address }}</p>
            <h5 class="secondary--text text--lighten-2">{{ $t('label.postcode') }}</h5>
            <p class="black--text text-body-2">{{ address.postcode }}</p>
            <v-switch inset v-model="address.default_billing_address" :label="$t('label.makeDefaultBillingAddress')" readonly />
            <v-switch inset v-model="address.default_delivery_address" :label="$t('label.makeDefaultShippingAddress')" readonly />
          </v-card-text>
          <v-card-actions>
            <app-button class="px-6 mb-4 mx-auto" invert :label="$t('button.remove')" @click="onRemove(address.id)" />
          </v-card-actions>
        </v-card>
      </div>
    </LayoutContent>
    <bottom-bar>
      <v-container class="py-3 d-flex align-center justify-center">
        <app-button
          width="12rem"
          :class="{
            'mr-6': $vuetify.breakpoint.smAndUp,
            'mr-2': !$vuetify.breakpoint.smAndUp
          }"
          :label="$t('label.addAddress')"
          :to="{ name: this.$route.path === '/order/address-book' ? $constants.ROUTE_NAME.ORDER_ADD_ADDRESS : $constants.ROUTE_NAME.PROFILE_ADD_ADDRESS }"
        />
        <app-button
          width="12rem"
          :class="{
            'ml-6': $vuetify.breakpoint.smAndUp,
            'ml-2': !$vuetify.breakpoint.smAndUp
          }"
          :label="$t('button.continueCheckout')"
          :to="{ name: $constants.ROUTE_NAME.ORDER_CHECK_OUT, params: { step: 2 } }"
          v-if="this.$route.path === '/order/address-book' && isCheckout"
        />
        <app-button
          width="12rem"
          :class="{
            'ml-6': $vuetify.breakpoint.smAndUp,
            'ml-2': !$vuetify.breakpoint.smAndUp
          }"
          :label="$t('button.back')"
          v-if="!isCheckout"
          @click="$router.go(-1)"
        />
      </v-container>
    </bottom-bar>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import SectionTitle from '@/components/SectionTitle.vue'
import LayoutContent from '../layouts/LayoutContent.vue'

export default {
  components: { LayoutContent, SectionTitle },

  data() {
    return {
      selectedTab: '',
      addressType: 'delivery',
      selectedDeliveryAddress: '',
      selectedBillingAddress: '',
      deliveryAddress: {
        type: 'delivery',
        addressName: 'Home 01',
        receiverName: 'Sarah',
        contactNum: '+65-9179 2639',
        email: 'sarah@gmail.com',
        unitNum: '01-01, Pearl Bank',
        address: '#31-10 Pearl Bank Apartments',
        postCode: '169016',
        setAsDefaultShipping: false,
        setAsDefaultBilling: false
      },

      billingAddress: {
        type: 'billing',
        addressName: 'Office 01',
        receiverName: 'Soroh',
        contactNum: '+65-9329 2639',
        email: 'soroh@gmail.com',
        unitNum: '01-01, Peorl Bonk',
        address: '#31-10 Peorl Bonk Oportments',
        postCode: '169016',
        setAsDefaultShipping: false,
        setAsDefaultBilling: false
      },
      isCheckout: false
    }
  },
  computed: { ...mapState('auth', ['addressList', 'currentDeliveryAddress', 'currentBillingAddress']) },
  created() {
    this.isCheckout = this.$route.params.isCheckout ? this.$route.params.isCheckout : false
    this.getAddress().then(() => {
      if (this.addressList.length > 0) {
        this.selectedDeliveryAddress = this.currentDeliveryAddress.id
        this.selectedBillingAddress = this.currentBillingAddress.id
      }
    })
  },
  methods: {
    ...mapActions('auth', ['getAddress', 'deleteAddress']),
    ...mapActions('order', ['editDeliveryAddress', 'editBillingAddress']),
    ...mapMutations('order', ['setArrangeDelivery']),
    ...mapMutations('auth', ['setCurrentDeliveryAddress', 'setCurrentBillingAddress']),
    async onRemove(id) {
      await this.deleteAddress(id)
        .then(() => {
          this.$toast.success(this.$t('message.deleteAddressSuccessfully'))
        })
        .catch(() => {
          this.$toast.error(this.$t('message.deleteAddressFailed'))
        })
    },
    billingAddressChange() {
      let index = this.addressList.findIndex((f) => f.id === this.selectedBillingAddress)
      this.editBillingAddress(his.addressList[index].id)
      this.setCurrentBillingAddress(this.addressList[index])
    },
    deliveryAddressChange() {
      let index = this.addressList.findIndex((f) => f.id === this.selectedDeliveryAddress)
      this.editDeliveryAddress(this.addressList[index].id)
      this.setCurrentDeliveryAddress(this.addressList[index])
    }
  }
}
</script>

<style lang="scss">
.address-book--tab {
  font-weight: bold;
  text-transform: capitalize;
}
.theme--light.v-tabs > .v-tabs-bar {
  background-color: transparent !important;
}
.tab {
  width: 50%;
}

.switch-height {
  height: 36px;
}

.radio--container {
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio-marker {
  padding-right: 2.6rem;
  height: 2.6rem;
  margin-right: 0.5rem;
}

.radio--container > input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.radio--container {
  /* radio circle */
  [type='radio']:not(:checked) + .radio-marker:before,
  [type='radio']:checked + .radio-marker:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 2.6rem;
    height: 2.6rem;
    border: 1px solid #aaa;
    background: #fff;
    border-radius: 999em;
    -webkit-transition: all 0.275s;
    transition: all 0.275s;
  }

  [type='radio']:checked + .radio-marker:before {
    background-color: var(--v-primary-darken1);
  }

  /* checked mark aspect */
  [type='radio']:not(:checked) + .radio-marker:after,
  [type='radio']:checked + .radio-marker:after {
    content: '';
    border-bottom: 2px solid white;
    border-right: 2px solid white;
    width: 0.5em;
    height: 1em;
    position: absolute;
    top: 0.1em;
    left: 0.48em;
    font-size: 1.15em;
    color: white;
    line-height: 0;
    -webkit-transition: all 0.2s;
    transition: all 0.2s;

    @media only screen and (min-width: 640px) {
      top: 0.1em;
      left: 0.45em;
      font-size: 1.375em;
    }
  }

  /* checked mark aspect changes */
  [type='radio']:not(:checked) + .radio-marker:after {
    opacity: 0;
    -webkit-transform: scale(0) rotate(-45deg);
    transform: scale(0) rotate(-45deg);
  }

  [type='radio']:checked + .radio-marker:after {
    opacity: 1;
    -webkit-transform: scale(1) rotate(45deg);
    transform: scale(1) rotate(45deg);
  }

  /* Accessibility */
  [type='radio']:checked:focus + .radio-marker:before,
  [type='radio']:not(:checked):focus + .radio-marker:before {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) inset, 0 0 0 4px rgba(var(--v-primary-darken1), 0.5);
  }
}
</style>
